export default class ChangeOrderLang {
  constructor (langList) {
    this.langList = langList.querySelector('ul')
    if (this.langList.childElementCount > 1) {
      const frLang = this.langList.querySelector('.js-lang-fr')
      const cloneFrLang = frLang.cloneNode(true)
      this.langList.prepend(cloneFrLang)
      frLang.remove()
    } else {
      this.langList.remove()
    }
  }
}
